import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Dictionary } from '@ngrx/entity';
import { ToggleButtonWrapperComponent } from 'src/app/components/buttons/toggle-button-wrapper.component';
import { AssetCardComponent } from 'src/app/components/cards/asset-card.component';
import { DialogWrapperComponent } from 'src/app/components/wrappers/dialog-wrapper.component';

@Component({
    selector: 'icon-selector',
    templateUrl: './icon.dialog.html',
    styles: [`
    h5 { margin-top: 20px; }
    .grey-hint { margin-top: 5px; font-size: 14px; }
    .toggle-button { display: block; margin-top: 5px; }
  `],
    standalone: true,
    imports: [DialogWrapperComponent, ToggleButtonWrapperComponent, AssetCardComponent],
})
export class IconDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: IconDialogData,
    public dialogRef: MatDialogRef<IconDialogComponent>,
  ) {}

  ngOnInit() {
    const { rect } = this.data
    this.dialogRef.updatePosition({ top: rect.y + 'px', left: rect.left + 'px' })
  }

  selectIcon(id: string) {
    console.log({ id })
    this.data.selectedIconId = id === this.data.selectedIconId ? null : id
    this.dialogRef.close()
  }

}

export interface IconDialogData {
  selectedIconId: string
  iconChoices: string[]
  nameMap: Dictionary<string>
  rect: DOMRect
}